export default "__VITE_ASSET__bfb60fd0__"